// src/utils/youtube.js

/**
 * Extrae el ID de un video de YouTube desde cualquiera de sus formatos:
 *   https://youtu.be/ID?si=...
 *   https://www.youtube.com/watch?v=ID
 *   https://youtube.com/shorts/ID?si=...
 *   https://www.youtube.com/embed/ID
 * Devuelve { id, esShort } o null si no es una URL de YouTube válida.
 */
export function parseYouTube(url) {
  if (!url || typeof url !== 'string') return null;
  const u = url.trim();

  // Shorts: youtube.com/shorts/ID
  const short = u.match(/youtube\.com\/shorts\/([A-Za-z0-9_-]{6,})/i);
  if (short) return { id: short[1], esShort: true };

  // Formato corto: youtu.be/ID
  const corto = u.match(/youtu\.be\/([A-Za-z0-9_-]{6,})/i);
  if (corto) return { id: corto[1], esShort: false };

  // Formato watch: youtube.com/watch?v=ID
  const watch = u.match(/[?&]v=([A-Za-z0-9_-]{6,})/i);
  if (watch) return { id: watch[1], esShort: false };

  // Formato embed: youtube.com/embed/ID
  const embed = u.match(/youtube\.com\/embed\/([A-Za-z0-9_-]{6,})/i);
  if (embed) return { id: embed[1], esShort: false };

  return null;
}

/** URL de embed lista para el iframe (privacidad reforzada con youtube-nocookie). */
export function youtubeEmbedUrl(id) {
  return `https://www.youtube-nocookie.com/embed/${id}`;
}

/** Miniatura del video (para previsualización sin cargar el iframe). */
export function youtubeThumb(id) {
  return `https://img.youtube.com/vi/${id}/hqdefault.jpg`;
}